module.exports = __webpack_public_path__ + "static/turquia-027-d00339191f373794fd2dd125fbdb6f96.jpg";